document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-card--variant').forEach(card => {
    const scroller = card.querySelector('[data-media-scroll]');
    const dotsWrap = card.querySelector('[data-variant-dots]');

    if (!scroller || !dotsWrap) return;

    const slides = scroller.querySelectorAll('img');
    if (slides.length <= 1) return;

    // Build dots
    dotsWrap.innerHTML = '';
    slides.forEach((_, i) => {
      const dot = document.createElement('span');
      dot.className = 'variant-dot' + (i === 0 ? ' is-active' : '');
      dotsWrap.appendChild(dot);

      dot.addEventListener('click', e => {
        e.stopPropagation();
        scroller.scrollTo({
          left: scroller.clientWidth * i,
          behavior: 'smooth'
        });
      });
    });

    const dots = dotsWrap.querySelectorAll('.variant-dot');

    // Sync dots on scroll
    let ticking = false;
    scroller.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const index = Math.round(
            scroller.scrollLeft / scroller.clientWidth
          );
          dots.forEach((dot, i) =>
            dot.classList.toggle('is-active', i === index)
          );
          ticking = false;
        });
        ticking = true;
      }
    });

    // Prevent media interaction from opening product
    ['click', 'pointerdown', 'touchstart'].forEach(evt => {
      scroller.addEventListener(evt, e => e.stopPropagation(), {
        passive: evt === 'touchstart'
      });
    });
  });
});
